<template>
    <div>
        <el-upload
                class="upload-demo"
                action=""
                :before-upload="beforeUpload"
                multiple  >
            <el-button size="small" type="primary" class="h-btn h-formBtn">点击导入</el-button>
        </el-upload>
    </div>

</template>
<script>
    import uploaddown from '../../utils/updownfile'
    import _ from 'loadsh'
    export default {
        props:{
            clsname:null,
            startrow:{
                type: Number,
                default: 0
            },
        },
        computed: {
            clsName:function(){
                    return this.clsname;
                },
            startRow:function () {
                return this.startrow;
            }
        },
        methods: {
            beforeUpload(file){
                uploaddown.importExcel(file, {clsname: this.clsName, startrow: this.startRow}).then(rd => {
                    if(rd.f){
                        this.$emit('scallback', rd);
                    }else{
                        this.$msg.alerte(rd.msg,()=>{
                            this.$emit('ecallback', rd);
                        })
                    }
                }).catch(error=>{
                    return Promise.reject(error);
                })
              return false;
            },
        },
    }
</script>
<style>
    .el-icon-close{
        display: block;
    }
    .el-upload-list__item.is-success .el-upload-list__item-status-label {
         width: auto!important;
         margin-top: 0px!important;
        right: 25px!important;
    }
    .el-upload-list__item .el-icon-close {
        display: block;
    }
    .el-upload-list__item.is-success:active .el-icon-close-tip, .el-upload-list__item.is-success:focus .el-upload-list__item-status-label, .el-upload-list__item.is-success:hover .el-upload-list__item-status-label, .el-upload-list__item.is-success:not(.focusing):focus .el-icon-close-tip {
        display: block!important;
    }
</style>
